import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const EyeOpen = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${EyeOpen.dimensions.width} ${EyeOpen.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="M1 11.386s13.729-21.119 30.183 0c0 0-14.438 18.32-30.183 0Z"
        stroke={color || Color.premiumBlack}
        fill="none"
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <Path
        d="M16 18.145c-3.859 0-7-3.171-7-7.072C9 7.172 12.141 4 16 4s7 3.172 7 7.073c0 3.9-3.141 7.072-7 7.072Zm0-13.473c-3.496 0-6.337 2.873-6.337 6.4 0 3.528 2.844 6.402 6.337 6.402s6.337-2.874 6.337-6.401c0-3.528-2.844-6.401-6.337-6.401Z"
        fill={color || Color.premiumBlack}
      />
      <Path
        d="M16 16.415c-2.917 0-5.291-2.398-5.291-5.346s2.374-5.346 5.29-5.346c2.918 0 5.292 2.398 5.292 5.346S18.917 16.415 16 16.415Zm0-10.024c-2.554 0-4.632 2.1-4.632 4.681 0 2.582 2.078 4.682 4.632 4.682s4.632-2.1 4.632-4.681c0-2.582-2.078-4.682-4.632-4.682Z"
        fill={color || Color.premiumBlack}
      />
      <Path
        d="M16 7.45c-1.978 0-3.586 1.625-3.586 3.623 0 1.998 1.608 3.622 3.586 3.622 1.978 0 3.586-1.624 3.586-3.622 0-1.998-1.608-3.623-3.586-3.623Zm2.93 3.623c0 1.631-1.315 2.961-2.93 2.961-1.616 0-2.93-1.33-2.93-2.961 0-1.632 1.314-2.962 2.93-2.962 1.615 0 2.93 1.33 2.93 2.962Z"
        fill={color || Color.premiumBlack}
      />
    </Svg>
  )
}

EyeOpen.dimensions = {
  width: 32,
  height: 21,
}

export default EyeOpen
